import { MenuItems } from "./MenuItems";

export const adminMenuItems: MenuItems[] = [
  {
    label: "Dashboard",
    path: "/admin",
    icon: "pi pi-home",
    allowedRoles: ["ADMIN", "SUPERADMIN", "REVIEWER"],
  },
  {
    label: "Users",
    path: "/admin/users",
    icon: "pi pi-user",
    allowedRoles: ["ADMIN", "SUPERADMIN"],
  },
  {
    label: "Customers",
    path: "/admin/customers",
    icon: "pi pi-users",
    allowedRoles: ["ADMIN", "SUPERADMIN", "REVIEWER"],
  },
  {
    label: "Transactions history",
    path: "/admin/transaction-history",
    icon: "pi pi-history",
    allowedRoles: ["ADMIN", "SUPERADMIN"],
  },
  {
    label: "Transactions log",
    path: "/admin/transaction-log",
    icon: "pi pi-align-justify",
    allowedRoles: ["ADMIN", "SUPERADMIN"],
  },
  {
    label: "Payment Link",
    path: "/admin/payment-link",
    icon: "pi pi-link",
    allowedRoles: ["ADMIN", "SUPERADMIN"],
  },
  {
    label: "Withdrawals",
    path: "/admin/manage-withdrawals",
    icon: "pi pi-credit-card",
    allowedRoles: ["ADMIN", "SUPERADMIN"],
  },
  {
    label: "Documents Type",
    path: "/admin/manage-document",
    icon: "pi pi-file",
    allowedRoles: ["ADMIN", "SUPERADMIN", "REVIEWER"],
  },
  {
    label: "Manage Partners",
    path: "/admin/partners",
    icon: "pi pi-building",
    allowedRoles: ["ADMIN", "SUPERADMIN"],
  },
  {
    label: "Monetary zones",
    path: "/admin/manage-monetary-zone",
    icon: "pi pi-chart-pie",
    allowedRoles: ["ADMIN", "SUPERADMIN"],
  },
  {
    label: "Payout",
    path: "/admin/payout",
    icon: "pi pi-send",
    allowedRoles: ["ADMIN", "SUPERADMIN"],
  },
  {
    label: "Countries",
    path: "/admin/countries-monetary-zone",
    icon: "pi pi-globe",
    allowedRoles: ["ADMIN", "SUPERADMIN"],
  },
  {
    label: "Services",
    path: "/admin/manage-service",
    icon: "pi pi-th-large",
    allowedRoles: ["ADMIN", "SUPERADMIN"],
  },
  {
    label: "User Roles",
    path: "/admin/manage-roles",
    icon: "pi pi-id-card",
    allowedRoles: ["ADMIN", "SUPERADMIN"],
  },
  {
    label: "Ip Address",
    path: "/admin/manage-ip-address",
    icon: "pi pi-server",
    allowedRoles: ["ADMIN", "SUPERADMIN"],
  },
  {
    label: "Maintenance Mode",
    path: "/admin/maintenance",
    icon: "pi pi-exclamation-circle",
    allowedRoles: ["ADMIN", "SUPERADMIN"],
  },
  {
    label: "Route Config",
    path: "/admin/route-config",
    icon: "pi pi-sitemap",
    allowedRoles: ["ADMIN", "SUPERADMIN"],
  },
  {
    label: "Audit Logs",
    path: "/admin/audit-logs",
    icon: "pi pi-shield",
    allowedRoles: ["ADMIN", "SUPERADMIN"],
  },
];
